module.exports = __webpack_public_path__ + "r-v3/img/ml_19_00.8eff930a.jpg";